import { render, staticRenderFns } from "./OpenboxRule.vue?vue&type=template&id=b2b1b358&scoped=true&"
import script from "./OpenboxRule.vue?vue&type=script&lang=js&"
export * from "./OpenboxRule.vue?vue&type=script&lang=js&"
import style0 from "./OpenboxRule.vue?vue&type=style&index=0&id=b2b1b358&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b1b358",
  null
  
)

export default component.exports